export default class GotoMarker extends Phaser.Image {
  constructor(game, x, y) {
    super(game, x, y, 'goto_marker');

    this.anchor.set(0.5);

    this.inputEnabled = true;
    this.events.onInputDown.addOnce(this.handleInputDown, this);
  }

  handleInputDown() {
    this.game.onboarding.handleGotoMarkerTap();
  }
}
